import React from "react";
import { observer } from "mobx-react-lite";
import LandingPageContainer, { LandingPageType } from "../LandingPageContainer";
import { useStore } from "../../../stores/Stores";
import { MeetingLogType } from "../../store/MeetingLogType";
import { useTranslation } from "../../../shared/translation/Translation";

const JoinMeeting: React.FC = observer(() => {
    const { meetingStore } = useStore();
    const messages = useTranslation();

    const redirectToMeeting = async (urlHash: string | null) => {
        if (!urlHash) {
            alert(messages.joinMeeting.wrongAddress);
            return;
        }

        const url = await meetingStore.getOriginJoinUrl(urlHash);

        if (!url) {
            alert(messages.joinMeeting.failedToJoin);
            return;
        }

        await meetingStore.addLog(meetingStore.meeting.meetingId, MeetingLogType.ClientJoined);
        window.location.replace(url);
    };

    return <LandingPageContainer primaryAction={redirectToMeeting} section={LandingPageType.Join} />;
});

export default JoinMeeting;
